// config is environment dependent

export default window.weezConfig;
